module.exports = __webpack_public_path__ + "static/media/cert_55.6912f69f.jpg";